/**
 *
 * [ used primarily in ./paymentCreationInfoTransformer.js ]
 */

import { CustomerVpaList } from './@types';
import { vpaTransformer } from './vpaTransformer';


export const customerVpaListTransformer = (customerVpaList: CustomerVpaList[]) => {
  let transformedArray: CustomerVpaList[] = [];
  if (!customerVpaList || !customerVpaList.length) {
    return transformedArray;
  }

  transformedArray = customerVpaList.map((vpa: CustomerVpaList) => vpaTransformer(vpa));

  return transformedArray;
};
